import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import SEO from "@/components/SEO";

export default function AdminSettings() {
    const [form, setForm] = useState({ site_language: "en", bank_account_info: "", contact_phone: "", contact_email: "", facebook_url: "", youtube_url: "", delivery_charge_inside_dhaka: 60, delivery_charge_outside_dhaka: 120 });
    const [busy, setBusy] = useState(false);

    useEffect(() => { api.get("/admin/settings").then((r) => setForm({ ...form, ...r.data })); /* eslint-disable-next-line */ }, []);

    const save = async (e) => {
        e.preventDefault();
        setBusy(true);
        try { await api.put("/admin/settings", form); toast.success("Saved"); }
        catch (err) { toast.error(formatApiError(err)); }
        finally { setBusy(false); }
    };

    const F = (k, v) => setForm({ ...form, [k]: v });

    return (
        <div className="max-w-2xl">
            <SEO title="Admin - Settings" />
            <h1 className="text-2xl font-bold text-brand-navy mb-6">Settings</h1>
            <form onSubmit={save} className="bg-white border border-brand-light rounded-2xl p-4 sm:p-6 space-y-4">
                <div>
                    <label className="block text-xs mb-1 font-medium">Default Site Language</label>
                    <Select value={form.site_language} onValueChange={(v) => F("site_language", v)}>
                        <SelectTrigger data-testid="settings-lang"><SelectValue /></SelectTrigger>
                        <SelectContent><SelectItem value="bn">বাংলা (Bangla)</SelectItem><SelectItem value="en">English</SelectItem></SelectContent>
                    </Select>
                </div>
                <Inp label="Contact Phone" value={form.contact_phone} onChange={(v) => F("contact_phone", v)} />
                <Inp label="Contact Email" type="email" value={form.contact_email} onChange={(v) => F("contact_email", v)} />
                <Inp label="Facebook URL" value={form.facebook_url} onChange={(v) => F("facebook_url", v)} />
                <Inp label="YouTube URL" value={form.youtube_url} onChange={(v) => F("youtube_url", v)} />
                <div className="grid grid-cols-2 gap-4">
                    <Inp label="Delivery Charge Inside Dhaka (৳)" type="number" value={form.delivery_charge_inside_dhaka} onChange={(v) => F("delivery_charge_inside_dhaka", Number(v))} />
                    <Inp label="Delivery Charge Outside Dhaka (৳)" type="number" value={form.delivery_charge_outside_dhaka} onChange={(v) => F("delivery_charge_outside_dhaka", Number(v))} />
                </div>
                <div>
                    <label className="block text-xs mb-1 font-medium">Bank Account Info (shown to customers at checkout)</label>
                    <textarea rows={5} value={form.bank_account_info} onChange={(e) => F("bank_account_info", e.target.value)} className="w-full px-3 py-2 rounded-lg border border-brand-light font-bn" data-testid="bank-info-textarea" />
                </div>
                <button disabled={busy} className="btn-primary px-5 py-2.5 rounded-lg font-semibold inline-flex items-center gap-2 disabled:opacity-60" data-testid="save-settings"><Save className="w-4 h-4" /> {busy ? "Saving..." : "Save Settings"}</button>
            </form>
        </div>
    );
}
function Inp({ label, value, onChange, type = "text" }) { return (<div><label className="block text-xs mb-1 font-medium">{label}</label><input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-brand-light" /></div>); }
